import Alpine from 'alpinejs';


window.Alpine = Alpine; 

document.addEventListener('alpine:init', () => {
    Alpine.store('layout', {});
});

Alpine.start();

